import { createGlobalStyle } from 'styled-components';
import breakpoints from './breakpoints';


const GlobalStyle = createGlobalStyle`
:root{
    --primary-color: #8F5212;
    --primary-color-light: #E8A33D;
    --secondary-color: #6c757d;
    --background-dark-color: #0B0D12;
    --background-dark-grey: #14171F;
    --border-color: #262B38;
    --background-light-color: #F1F1F1;
    --background-light-color-2: rgba(255,255,255,.06);
    --white-color: #E8E9ED;
    --font-light-color: #9AA1B2;
    --font-dark-color: #313131;
    --font-dark-color-2: #151515;
    --sidebar-dark-color: #14171F;
    --font-mono: 'IBM Plex Mono', ui-monospace, monospace;
    --scrollbar-bg-color: #383838;
    --scrollbar-thump-color: #6b6b6b;
    --scrollbar-track-color: #383838;
    
    /* Typography Scale */
    --font-size-h1: 4rem;
    --font-size-h2: 2.5rem;
    --font-size-h3: 2rem;
    --font-size-h4: 1.6rem;
    --font-size-h5: 1.4rem;
    --font-size-h6: 1.2rem;
    --font-size-body: 1rem;
    --font-size-small: 0.875rem;
}
.light-theme{
    --primary-color: #0062cc;
    --primary-color-light: #1a8aff;
    --secondary-color: #ff7675;
    --background-dark-color: #F1F1F1;
    --background-dark-grey: #e4e4e4;
    --border-color: #cbced8;
    --background-light-color: #F1F1F1;
    --background-light-color-2: rgba(3,127,255,.3);
    --white-color: #151515;
    --font-light-color: #313131;
    --font-light-color2: #fff;
    --font-dark-color: #313131;
    --font-dark-color-2: #151515;
    --sidebar-dark-color: #E4E4E4;
    --scrollbar-bg-color: #383838;
    --scrollbar-thump-color: #6b6b6b;
    --scrollbar-track-color: #383838;
}
.dark-theme{
    --primary-color: #8F5212;
    --primary-color-light: #E8A33D;
    --secondary-color: #6c757d;
    --background-dark-color: #0B0D12;
    --background-dark-grey: #14171F;
    --border-color: #262B38;
    --background-light-color: #F1F1F1;
    --background-light-color-2: rgba(255,255,255,.06);
    --white-color: #E8E9ED;
    --font-light-color: #9AA1B2;
    --font-dark-color: #313131;
    --font-dark-color-2: #151515;
    --sidebar-dark-color: #14171F;
    --font-mono: 'IBM Plex Mono', ui-monospace, monospace;
    --scrollbar-bg-color: #383838;
    --scrollbar-thump-color: #6b6b6b;
    --scrollbar-track-color: #383838;
}
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    list-style: none;
    text-decoration: none;
    font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 1.1rem;
    
}
html{
    color-scheme: dark;
}
body{
    background-color: var(--background-dark-color);
    color: var(--font-light-color);
    transition: background-color .4s ease-in-out, color .4s ease-in-out;
}
body::-webkit-scrollbar{
    width: 9px;
    background-color: #383838;
}
body::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #6b6b6b;
}
body::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: #383838;
}
textarea{
    max-width: 100%;
}
a{
    font-family: inherit;
    color: inherit;
    font-size: inherit;
    font-size: var(--font-size-body);
}
h1{
    font-size: var(--font-size-h1);
    color: var(--white-color);
    font-weight: 600;
    span{
        font-size: var(--font-size-h1);
        @media screen and (max-width: ${breakpoints.mobileHeading}){
            font-size: 3rem
        }
    }
    @media screen and (max-width: ${breakpoints.mobileHeading}){
        font-size: 3rem
    }
}
h2{
    font-size: var(--font-size-h2);
    color: var(--white-color);
    font-weight: 600;
}
h3{
    font-size: var(--font-size-h3);
    color: var(--white-color);
    font-weight: 600;
}
h4{
    font-size: var(--font-size-h4);
    color: var(--white-color);
    font-weight: 600;
}
h5{
    font-size: var(--font-size-h5);
    color: var(--white-color);
    font-weight: 600;
}
h6{
    color: var(--white-color);
    font-size: var(--font-size-h6);
    font-weight: 600;
    padding-bottom: .6rem;
}
p{
    font-size: var(--font-size-body);
    line-height: 1.6;
}
span{
    color: inherit;
}
//Utilities
.u-margin-bottom{
    margin-bottom: 4rem;
}
`;

export default GlobalStyle;